import type { Collection } from '../domain/collections';

export type AudienceActions = {
  leave: boolean;
  mute: boolean;
  unmute: boolean;
  makePrivate: boolean;
  members: boolean;
};

/**
 * Which audience actions a collection offers me, from how I relate to it
 * (015 FR-012, FR-015, FR-019, FR-025). The server still decides; this only
 * keeps screens from offering what it would refuse.
 */
export function audienceActionsFor(c: Collection): AudienceActions {
  const member = c.myRelation === 'contributor' || c.myRelation === 'viewer';
  return {
    leave: member && c.visibility === 'private',
    mute: c.myRelation === 'follower' && c.visibility === 'open',
    // A kept mute on a private collection can still be undone (Q3).
    unmute: c.myRelation !== 'owner',
    makePrivate: c.myRelation === 'owner' && c.visibility === 'open' && !c.isDefault,
    members: c.visibility === 'private',
  };
}

/** What leaving a private collection does, and how to come back (015 US3). */
export function leaveCollectionMessage(c: Collection): string {
  const owner = c.owner.firstName;
  return `You won't see ${c.name} or its listings any more. You'll stay connected with ${owner}. An invite from ${owner} can bring you back.`;
}

/** Only I see that I muted it (015 FR-018). */
export const MUTED_COLLECTION_NOTE = "You've muted this collection.";
